
import {
    SET_ALL_INDI_PROGRAMS,
    SET_INDI_PROGRAMS,
} from './types';

import { apiCallV2 } from "../../utils/api";

export const GetAllIndiPrograms = (page = 1, count = 100, filter = {}, sort = null) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "get-indi-programs-v2",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    dispatch({
        type: SET_ALL_INDI_PROGRAMS,
        data: {
            list: res.data.programs,
            count: res.data.count[0]["count(*)"]
        }
    })

}

export const GetIndiPrograms = (page, count, filter = {}, sort = null) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "get-indi-programs",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    dispatch({
        type: SET_INDI_PROGRAMS,
        data: {
            list: res.data.programs,
            count: res.data.count[0]["count(*)"]
        }
    })

}


export const UpdateIndiProgram = (program) => async (dispatch) => {
    const res = await apiCallV2(
        "POST",
        "indi-program/update",
        {
            program: program
        },
        localStorage.getItem("access-token"),
    );

    return res?.data?.data?.success || false;

}